export default "import React from 'react';\nimport { Button } from 'example';\n\nexport default () => <Button variant=\"solid\">Primary</Button>;\n";